import React from 'react';
import { formatNumber } from '@progress/kendo-intl';
import Disclaimer from '../shared/Disclaimer';
import Api from '../../services/api/api';

export default class Worksheet extends React.Component {

    constructor(props) {
        super(props);

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        this.defaultPatient = {
            Name: '',
            PatientId: '',
            Balance: 0,
            BadDebt: 0
        };

        this.defaultProvider = {
            Name: '',
            Type: '',
            IsPcp: false
        };

        this.defaultInsurance = {
            Name: '',
            Type: ''
        };

        this.defaultLocation = {
            DepartmentId: 0,
            Name: '',
            IsFacility: false,
            IsTrauma: false
        };

        this.defaultState = {
            id: null,
            estimateDate: today,
            dateOfService: today,
            deductible: 0,
            paidIn: 0,
            coinsurance: 0,
            copay: 0,
            maxOutOfPocket: 0,
            maxOutOfPocketPaidIn: 0,
            maxOutOfPocketRemaining: 0,
            codeList: [],
            selectedPatient: this.defaultPatient,
            selectedProvider: this.defaultProvider,
            selectedInsurance: this.defaultInsurance,
            selectedLocation: this.defaultLocation
        };

        this.state = this.defaultState;
    }

    componentDidMount() {
        // Initialize state either from estimateId or default state
        this.initializeState(this.props.estimateId);
    }

    initializeState(estimateId) {

        this.setState(this.defaultState, () => {
            Api.getSummary(estimateId)
                .then((result) => {
                    if (result) {
                        console.debug('Loaded state...');
                        console.debug(result);

                        this.setState(result);

                        // Print the page. Close when dialog closes
                        window.onafterprint = function () {
                            window.close();
                        }
                        window.print();
                        //setTimeout(window.close, 0);
                    } else {
                        // State was not loaded.
                        // The estimate is invalid.
                        // Redirect to home.

                        this.isPrintable = false;
                        window.location.href = '/';
                    }
                });
        })
    }

    render() {
        const apiService = new Api(this.state);

        // Turn our codeList into a series of CodeTableRow components
        const rows = this.state.codeList.map((row, i) => (<tr key={i}>
                                                    <td>{row.code}</td>
                                                    <td>{row.name}</td>
                                                    <td>{row.units}</td>
                                                    <td className="numeric">{formatNumber(row.units * row.chargeAmount, '$0.00')}</td>
                                                    </tr>));

        return (
            <div>
                <div id="header" className="section">
                    <div className="col-8">
                        <h1>Estimate Worksheet</h1>
                    </div>

                    <div className="col-4 pull-right">
                        <label>Estimate ID</label>
                        <div>{this.state.id}</div>
                        <label>Estimate Date</label>
                        <div>{this.state.estimateDate.toLocaleDateString()}</div>
                        <label>Date of Service</label>
                        <div>{this.state.dateOfService.toLocaleDateString()}</div>
                    </div>
                </div>

                <div id="patientInfo" className="section">
                    <hr />
                    <div className="col-8">
                        <h2>Customer Information</h2>

                        <label>Customer Name</label>
                        <div>{this.state.selectedPatient.name}</div>
                        <label>Patient ID</label>
                        <div>{this.state.selectedPatient.patientId}</div>
                        <label>Provider</label>
                        <div>{this.state.selectedProvider.name}</div>
                        <label>Insurance</label>
                        <div>{this.state.selectedInsurance.name}</div>
                        <label>Location</label>
                        <div>{this.state.selectedLocation.name}</div>
                    </div>
                </div>

                <div id="benefitInfo" className="section">
                    <hr />
                    <h2>Benefit Information</h2>

                    <div className="col-3">
                        <label>Deductible</label>
                        <div className="numeric">{formatNumber(this.state.deductible, '$0.00')}</div>
                        <label>Met</label>
                        <div className="numeric">{formatNumber(this.state.paidIn, '$0.00')}</div>
                        <label>Owed</label>
                        <div className="numeric">{formatNumber(apiService.calculateRemainingDeductible(), '$0.00')}</div>
                        <label>Co-Insurance</label>
                        <div className="numeric">{formatNumber(this.state.coinsurance).format('0.00%')}</div>
                        <label>Copay</label>
                        <div className="numeric">{formatNumber(this.state.copay, '$0.00')}</div>
                    </div>
                    <div className="col-1">
                        &nbsp;
                    </div>
                    <div className="col-8">
                        <div>The estimate is based on the following codes:</div>
                        <table>
                            <thead>
                                <tr>
                                    <th>Code</th>
                                    <th>Procedure</th>
                                    <th>Units</th>
                                    <th className="numeric">Cost</th>
                                </tr>
                            </thead>
                            <tbody>
                                {rows}
                            </tbody>
                        </table>
                    </div>
                </div>

                <div id="summary" className="section">
                    <hr />
                    <h2>Summary</h2>

                    <div className="col-5">
                        <label>Estimated Charges</label>
                        <div className="numeric">{formatNumber(apiService.calculateCharges(), '$0.00')}</div>
                        <label>Estimated Allowables</label>
                        <div className="numeric">{formatNumber(apiService.calculateAllowables(), '$0.00')}</div>
                        <label>Maximum Out Of Pocket</label>
                        <div className="numeric">{formatNumber(apiService.calculateMaxOutOfPocketRemaining(), '$0.00')}</div>
                        <label>Copay Amount</label>
                        <div className="numeric">{formatNumber(apiService.calculateSummaryCopay(), '$0.00')}</div>
                        <label>Deductible Amount</label>
                        <div className="numeric">{formatNumber(apiService.calculateSummaryDeductible(), '$0.00')}</div>
                        <label>Co-insurance Amount</label>
                        <div className="numeric">{formatNumber(apiService.calculateSummaryCoinsurance(), '$0.00')}</div>
                        <label>Estimated Total Customer Amount</label>
                        <div className="numeric">{formatNumber(apiService.calculateOutOfPocketAmount(), '$0.00')}</div>
                        <label>Personal Balance</label>
                        <div className="numeric">{formatNumber(this.state.selectedPatient.Balance, '$0.00')}</div>
                        <label>Outstanding Balance</label>
                        <div className="numeric">{formatNumber(this.state.selectedPatient.BadDebt, '$0.00')}</div>
                        <div className="total">
                            <label>Grand Total Balance</label>
                            <div className="numeric">{formatNumber(apiService.calculateTotalDue(), '$0.00')}</div>
                        </div>
                    </div>
                </div>

                <div id="disclaimer" className="section">
                    <Disclaimer />
                </div>                
            </div>
        );
    }
}